module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "als"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "als-loading"
  }, [_c('div', {
    staticClass: "als-spinner"
  })]) : _vm._e(), _vm._v(" "), (_vm.loadError && !_vm.loading) ? _c('div', {
    staticClass: "als-error"
  }, [_c('p', {
    staticClass: "als-error-title"
  }, [_vm._v("Could not load alert settings")]), _vm._v(" "), _c('p', {
    staticClass: "als-error-msg"
  }, [_vm._v(_vm._s(_vm.loadError))]), _vm._v(" "), _c('button', {
    staticClass: "als-btn als-btn-outline",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.fetchAll
    }
  }, [_vm._v("Retry")])]) : _vm._e(), _vm._v(" "), (!_vm.loading && !_vm.loadError) ? [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "als-hint-banner",
    attrs: {
      "role": "note"
    }
  }, [_c('svg', {
    staticClass: "als-hint-icon",
    attrs: {
      "width": "18",
      "height": "18",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "aria-hidden": "true"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 16v-4"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 8h.01"
    }
  })]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), (_vm.showInboxMode) ? _c('div', {
    staticClass: "als-config-card als-inbox-card"
  }, [_c('div', {
    staticClass: "als-config-top"
  }, [_c('div', [_c('h3', {
    staticClass: "als-config-title"
  }, [_vm._v("Inbox mode")]), _vm._v(" "), _c('p', {
    staticClass: "als-config-hint"
  }, [_vm._v("How alert emails land in your inbox."), (!_vm.canEditThreadedAlerts) ? [_vm._v(" Only the account owner or an admin can change this.")] : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "als-inbox-options",
    attrs: {
      "role": "radiogroup",
      "aria-label": "Inbox mode"
    }
  }, _vm._l((_vm.inboxModeOptions), function(opt) {
    return _c('label', {
      key: opt.value,
      staticClass: "als-inbox-option",
      class: {
        'als-inbox-option-sel': _vm.threadedAlerts === opt.value,
        'als-toggle-busy': _vm.inboxModeSaving
      }
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "name": "als-inbox-mode",
        "disabled": _vm.inboxModeSaving || !_vm.canEditThreadedAlerts
      },
      domProps: {
        "checked": _vm.threadedAlerts === opt.value
      },
      on: {
        "change": function($event) {
          return _vm.onInboxModeChange(opt.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "als-inbox-option-text"
    }, [_c('strong', [_vm._v(_vm._s(opt.label))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(opt.hint))])])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "als-config-card als-digest-card"
  }, [_c('div', {
    staticClass: "als-config-top"
  }, [_vm._m(2), _vm._v(" "), _c('label', {
    staticClass: "als-toggle",
    class: {
      'als-toggle-busy': _vm.digestSaving
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "disabled": _vm.digestSaving
    },
    domProps: {
      "checked": _vm.offerActivityDigest
    },
    on: {
      "change": function($event) {
        return _vm.onDigestToggle($event.target.checked)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "als-toggle-slider"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "als-config-card"
  }, [_c('div', {
    staticClass: "als-config-top"
  }, [_c('div', [_c('h3', {
    staticClass: "als-config-title"
  }, [_vm._v("Configuring alerts for")]), _vm._v(" "), _c('p', {
    staticClass: "als-config-hint"
  }, [_vm._v(_vm._s(_vm.isOwner ? 'Admin only · Members receive alerts based on this configuration' : 'Your personal alert preferences'))])]), _vm._v(" "), (_vm.dropdownUsers.length) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedUserEmail),
      expression: "selectedUserEmail"
    }],
    staticClass: "als-user-select",
    attrs: {
      "disabled": !_vm.isOwner
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedUserEmail = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.dropdownUsers), function(u) {
    return _c('option', {
      key: u.email,
      domProps: {
        "value": u.email
      }
    }, [_vm._v(_vm._s(_vm.formatUserLabel(u)))])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "als-brands"
  }, [(_vm.hasMultiMp) ? _c('div', {
    staticClass: "als-mp-default-head"
  }, [_c('span', {
    staticClass: "als-mp-default-title"
  }, [_vm._v("Default marketplaces")]), _vm._v(" "), _c('span', {
    staticClass: "als-mp-default-hint"
  }, [_vm._v("Every alert sends for these unless you give it its own marketplaces below.")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.assignedStorefronts), function(br) {
    return _c('div', {
      key: br.key,
      staticClass: "als-brand-row"
    }, [_c('span', {
      staticClass: "als-brand-name"
    }, [_vm._v(_vm._s(br.name))]), _vm._v(" "), (_vm.sfMpCodes(br).length > 1) ? _c('div', {
      staticClass: "als-mp-chips",
      attrs: {
        "role": "group",
        "aria-label": br.name + ' default marketplaces'
      }
    }, [_c('button', {
      class: ['als-mp-chip', 'als-mp-chip-all', {
        active: _vm.mpIsAll(_vm.defaultMpScope, br)
      }],
      attrs: {
        "type": "button",
        "aria-pressed": _vm.mpIsAll(_vm.defaultMpScope, br) ? 'true' : 'false',
        "disabled": !_vm.mpDefaultEditable
      },
      on: {
        "click": function($event) {
          return _vm.setMpAll(_vm.defaultMpScope, br)
        }
      }
    }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.sfMpCodes(br)), function(mp) {
      return _c('button', {
        key: 'dmp-' + br.key + '-' + mp.code,
        class: ['als-mp-chip', {
          active: _vm.mpChipOn(_vm.defaultMpScope, br, mp.code)
        }],
        attrs: {
          "type": "button",
          "aria-pressed": _vm.mpChipOn(_vm.defaultMpScope, br, mp.code) ? 'true' : 'false',
          "disabled": !_vm.mpDefaultEditable
        },
        on: {
          "click": function($event) {
            return _vm.toggleMpChip(_vm.defaultMpScope, br, mp.code)
          }
        }
      }, [_c('i', {
        class: _vm.mpFlagClass(mp.raw) + ' flag'
      }), _vm._v(_vm._s(_vm.mpLabel(mp.raw)))])
    })], 2) : _c('div', {
      staticClass: "als-mp-tags"
    }, _vm._l((br.mpCodes), function(code) {
      return _c('span', {
        key: code,
        staticClass: "als-mp-tag"
      }, [_c('i', {
        class: _vm.mpFlagClass(code) + ' flag'
      }), _vm._v(_vm._s(_vm.mpLabel(code)) + "\n            ")])
    }), 0), _vm._v(" "), (_vm.mpStale(_vm.defaultMpScope, br)) ? _c('p', {
      staticClass: "als-mp-warn"
    }, [_vm._v("No active marketplace selected for " + _vm._s(br.name) + ". Alerts that follow your default send nothing for it.")]) : _vm._e()])
  }), _vm._v(" "), (!_vm.assignedStorefronts.length) ? _c('p', {
    staticClass: "als-muted-sm"
  }, [_vm._v("No storefronts assigned.")]) : _vm._e()], 2), _vm._v(" "), _c('p', {
    staticClass: "als-config-footer"
  }, [_vm._v("\n        Assignment managed in "), _c('router-link', {
    staticClass: "als-link",
    attrs: {
      "to": "/settings/account"
    }
  }, [_vm._v("Account & Team")]), _vm._v(".\n        Narrow any alert to specific storefronts using the Storefronts selector on each alert.\n        "), (_vm.hasMultiMp) ? [_vm._v("Products in muted marketplaces are still tracked and stay on your dashboard.")] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "als-config-card als-locale-card"
  }, [_c('div', {
    staticClass: "als-config-top"
  }, [_vm._m(3), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notificationLocale),
      expression: "notificationLocale"
    }],
    staticClass: "als-user-select",
    attrs: {
      "disabled": _vm.localeSaving || (!_vm.isOwner && _vm.selectedUserEmail !== _vm.loginEmail)
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.notificationLocale = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.saveNotificationLocale]
    }
  }, _vm._l((_vm.notificationLocaleOptions), function(opt) {
    return _c('option', {
      key: opt.code,
      domProps: {
        "value": opt.code
      }
    }, [_vm._v(_vm._s(opt.label))])
  }), 0)]), _vm._v(" "), (_vm.localeSaving) ? _c('p', {
    staticClass: "als-muted-sm"
  }, [_vm._v("Saving language…")]) : (_vm.localeError) ? _c('p', {
    staticClass: "als-error-msg als-locale-error"
  }, [_vm._v(_vm._s(_vm.localeError))]) : (_vm.localeSaved) ? _c('p', {
    staticClass: "als-muted-sm als-locale-saved"
  }, [_vm._v("Language saved.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "als-panel"
  }, _vm._l((_vm.categorizedRows), function(cat) {
    return _c('div', {
      key: 'cat-' + cat.name
    }, [_c('div', {
      staticClass: "als-cat"
    }, [_vm._v(_vm._s(cat.name))]), _vm._v(" "), _vm._l((cat.rows), function(row) {
      return _c('div', {
        key: row.id,
        staticClass: "als-row-wrap"
      }, [_c('div', {
        staticClass: "als-row",
        class: {
          'als-row-locked': _vm.rowLocked(row)
        }
      }, [_c('div', {
        staticClass: "als-row-main"
      }, [_c('div', {
        staticClass: "als-alert-title"
      }, [_vm._v("\n                " + _vm._s(row.title) + "\n                "), (_vm.mpPillVisible(row)) ? _c('span', {
        class: ['als-mp-pill', {
          'als-mp-pill-own': _vm.rowMpOwn(row)
        }]
      }, [_vm._v(_vm._s(_vm.mpPillText(row)))]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "als-alert-desc"
      }, [_c('span', {
        staticClass: "als-includes-label"
      }, [_vm._v("Includes:")]), _vm._v("\n                " + _vm._s(row.includes) + "\n                "), (row.note) ? _c('span', {
        staticClass: "als-note"
      }, [_vm._v(_vm._s(row.note))]) : _vm._e()])]), _vm._v(" "), _c('div', {
        staticClass: "als-row-controls"
      }, [_c('div', {
        staticClass: "als-row-controls-stack"
      }, [_c('div', {
        staticClass: "als-row-controls-top"
      }, [(row.alwaysOn) ? _c('span', {
        staticClass: "als-pill-on"
      }, [_vm._v("Always on")]) : (_vm.rowLocked(row)) ? _c('span', {
        staticClass: "als-starter-lock als-starter-lock--toggle"
      }, [_c('svg', {
        attrs: {
          "width": "14",
          "height": "14",
          "viewBox": "0 0 20 20",
          "fill": "currentColor"
        }
      }, [_c('path', {
        attrs: {
          "fill-rule": "evenodd",
          "d": "M5 9V7a5 5 0 0110 0v2h1a2 2 0 012 2v6a2 2 0 01-2 2H4a2 2 0 01-2-2v-6a2 2 0 012-2h1zm2 0h6V7a3 3 0 10-6 0v2z",
          "clip-rule": "evenodd"
        }
      })]), _vm._v("\n                    Starter+\n                  ")]) : [(_vm.showStorefrontChip(row)) ? _c('div', {
        staticClass: "als-sf-chip",
        on: {
          "click": function($event) {
            $event.stopPropagation();
          }
        }
      }, [_c('button', {
        staticClass: "als-sf-chip-btn",
        attrs: {
          "type": "button",
          "title": _vm.storefrontChipTooltip(row),
          "aria-expanded": _vm.openStorefrontRowId === row.id ? 'true' : 'false'
        },
        on: {
          "click": function($event) {
            return _vm.toggleStorefrontMenu(row)
          }
        }
      }, [_vm._v(_vm._s(_vm.storefrontChipLabel(row)) + " "), _c('span', {
        staticClass: "als-sf-caret"
      }, [_vm._v("▾")])]), _vm._v(" "), (_vm.openStorefrontRowId === row.id) ? _c('div', {
        staticClass: "als-sf-menu",
        attrs: {
          "role": "dialog",
          "aria-label": "Storefronts for this alert"
        }
      }, [_c('label', {
        staticClass: "als-sf-opt"
      }, [_c('input', {
        attrs: {
          "type": "radio",
          "name": 'sf-mode-' + row.id
        },
        domProps: {
          "checked": !_vm.rowSellerIdsFor(row).length
        },
        on: {
          "change": function($event) {
            return _vm.setStorefrontsAll(row)
          }
        }
      }), _vm._v("\n                          All storefronts\n                        ")]), _vm._v(" "), _c('label', {
        staticClass: "als-sf-opt"
      }, [_c('input', {
        attrs: {
          "type": "radio",
          "name": 'sf-mode-' + row.id
        },
        domProps: {
          "checked": _vm.rowSellerIdsFor(row).length > 0
        },
        on: {
          "change": function($event) {
            return _vm.setStorefrontsOnly(row)
          }
        }
      }), _vm._v("\n                          Only selected:\n                        ")]), _vm._v(" "), _c('div', {
        staticClass: "als-sf-list"
      }, _vm._l((_vm.assignedStorefronts), function(sf) {
        return _c('label', {
          key: 'sf-' + row.id + '-' + sf.key,
          staticClass: "als-sf-opt"
        }, [_c('input', {
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": _vm.storefrontSelected(row, sf.id)
          },
          on: {
            "change": function($event) {
              return _vm.onStorefrontCheck(row, sf.id, $event.target.checked, $event)
            }
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "als-sf-name"
        }, [_vm._v(_vm._s(sf.name))]), _vm._v(" "), _c('span', {
          staticClass: "als-sf-flags"
        }, _vm._l((sf.mpCodes), function(code) {
          return _c('i', {
            key: 'f-' + sf.key + '-' + code,
            class: _vm.mpFlagClass(code) + ' flag',
            attrs: {
              "title": _vm.mpLabel(code)
            }
          })
        }), 0)])
      }), 0), _vm._v(" "), (_vm.storefrontMenuError[row.id]) ? _c('p', {
        staticClass: "als-sf-err"
      }, [_vm._v(_vm._s(_vm.storefrontMenuError[row.id]))]) : _vm._e(), _vm._v(" "), _c('p', {
        staticClass: "als-sf-note"
      }, [_vm._v("“All” also covers storefronts you add later.")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('label', {
        staticClass: "als-toggle"
      }, [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": _vm.rowOn(row)
        },
        on: {
          "change": function($event) {
            return _vm.onRowToggle(row, $event.target.checked)
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "als-toggle-slider"
      })])]], 2), _vm._v(" "), (row.delayMinutesConfigurable && _vm.rowOn(row) && !_vm.rowLocked(row)) ? _c('div', {
        staticClass: "als-row-controls-bottom als-delay-inline"
      }, [_c('div', {
        staticClass: "als-seg",
        attrs: {
          "role": "group",
          "aria-label": "Buy Box alert delay"
        }
      }, [_c('button', {
        class: ['als-seg-btn', {
          active: !_vm.isBuyboxDelayCustom(row)
        }],
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            return _vm.setBuyboxDelayImmediate(row)
          }
        }
      }, [_vm._v("Real-time")]), _vm._v(" "), _c('button', {
        class: ['als-seg-btn', {
          active: _vm.isBuyboxDelayCustom(row)
        }],
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            return _vm.enableBuyboxDelayInput(row)
          }
        }
      }, [_vm._v("Custom")])]), _vm._v(" "), (_vm.isBuyboxDelayCustom(row)) ? [_c('input', {
        class: ['als-delay-input', {
          'als-delay-input-err': !!_vm.delayErrorForRow(row)
        }],
        attrs: {
          "type": "number",
          "min": "20",
          "max": "40",
          "step": "1"
        },
        domProps: {
          "value": _vm.delayDraftForRow(row)
        },
        on: {
          "input": function($event) {
            return _vm.onBuyboxDelayInput(row, $event.target.value)
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "als-delay-unit"
      }, [_vm._v("min")])] : _vm._e()], 2) : (!row.delayMinutesConfigurable && (row.alwaysOn || row.digestFixed || _vm.deliveryRealtimeBadgeOnly(row) || (!_vm.rowLocked(row) && !row.alwaysOn && !_vm.deliveryRealtimeBadgeOnly(row)))) ? _c('div', {
        staticClass: "als-row-controls-bottom"
      }, [(row.alwaysOn) ? [_c('span', {
        staticClass: "als-badge-freq"
      }, [_vm._v(_vm._s(row.digestFixed ? 'Digest' : 'Real-time'))])] : (row.digestFixed) ? [_c('span', {
        staticClass: "als-badge-freq"
      }, [_vm._v("Digest")])] : (_vm.deliveryRealtimeBadgeOnly(row)) ? [_c('span', {
        staticClass: "als-badge-freq"
      }, [_vm._v(_vm._s(row.fixedBadge || 'Real-time'))])] : [_c('div', {
        staticClass: "als-seg",
        attrs: {
          "role": "group"
        }
      }, _vm._l((_vm.deliveryOptionsForRow(row)), function(opt) {
        return _c('button', {
          key: opt,
          class: ['als-seg-btn', {
            active: _vm.deliveryFor(row) === opt
          }],
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.setDelivery(row, opt)
            }
          }
        }, [_vm._v(_vm._s(opt === 'realtime' ? 'Real-time' : (opt === 'daily' ? 'Daily' : 'Weekly')))])
      }), 0)]], 2) : _vm._e()]), _vm._v(" "), (row.delayMinutesConfigurable && _vm.rowOn(row) && !_vm.rowLocked(row) && _vm.delayErrorForRow(row)) ? _c('p', {
        staticClass: "als-delay-error-inline"
      }, [_vm._v(_vm._s(_vm.delayErrorForRow(row)))]) : _vm._e(), _vm._v(" "), (_vm.storefrontSelectionStale(row)) ? _c('p', {
        staticClass: "als-sf-warn"
      }, [_vm._v("No assigned storefronts selected — this alert won't send.")]) : _vm._e()])]), _vm._v(" "), (_vm.subtypeBoxVisible(row)) ? _c('details', {
        staticClass: "als-bf als-st",
        attrs: {
          "open": !!_vm.subtypeBoxOpen[row.id]
        },
        on: {
          "toggle": function($event) {
            return _vm.$set(_vm.subtypeBoxOpen, row.id, $event.target.open)
          }
        }
      }, [_c('summary', {
        staticClass: "als-bf-head"
      }, [_c('span', {
        staticClass: "als-bf-caret"
      }, [_vm._v("▸")]), _vm._v("Alert me about\n              "), _c('span', {
        staticClass: "als-bf-sub"
      }, [_vm._v("— " + _vm._s(_vm.subtypeSummary(row)))])]), _vm._v(" "), _c('div', {
        staticClass: "als-st-grid",
        attrs: {
          "role": "group",
          "aria-label": row.title + ' types'
        }
      }, _vm._l((_vm.subtypeOptions(row)), function(opt) {
        return _c('label', {
          key: 'st-' + row.id + '-' + opt.key,
          staticClass: "als-st-opt"
        }, [_c('input', {
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": _vm.subtypeOn(row, opt.key)
          },
          on: {
            "change": function($event) {
              return _vm.onSubtypeCheck(row, opt.key, $event.target.checked, $event)
            }
          }
        }), _vm._v("\n                " + _vm._s(opt.label) + "\n              ")])
      }), 0), _vm._v(" "), (_vm.subtypeError[row.id]) ? _c('p', {
        staticClass: "als-mp-warn"
      }, [_vm._v(_vm._s(_vm.subtypeError[row.id]))]) : _vm._e(), _vm._v(" "), _c('p', {
        staticClass: "als-bf-ro"
      }, [(_vm.mutedSubtypesFor(row).length) ? _c('button', {
        staticClass: "als-st-reset",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            return _vm.setAllSubtypes(row)
          }
        }
      }, [_vm._v("Turn all back on")]) : _vm._e(), _vm._v("\n              New types Amazon adds later are on automatically.\n            ")])]) : _vm._e(), _vm._v(" "), (row.settingsKey === 'review_health' && _vm.rowOn(row) && !_vm.rowLocked(row)) ? _c('details', {
        staticClass: "als-bf als-st",
        attrs: {
          "open": !!_vm.settingsBoxOpen[row.id]
        },
        on: {
          "toggle": function($event) {
            return _vm.$set(_vm.settingsBoxOpen, row.id, $event.target.open)
          }
        }
      }, [_c('summary', {
        staticClass: "als-bf-head"
      }, [_c('span', {
        staticClass: "als-bf-caret"
      }, [_vm._v("▸")]), _vm._v("Sensitivity\n              "), _c('span', {
        staticClass: "als-bf-sub"
      }, [_vm._v("— " + _vm._s(_vm.reviewSensitivitySummary(row)))])]), _vm._v(" "), _c('p', {
        staticClass: "als-settings-label"
      }, [_vm._v("Star rating drop")]), _vm._v(" "), _c('div', {
        staticClass: "als-st-grid",
        attrs: {
          "role": "radiogroup",
          "aria-label": row.title + ' rating sensitivity'
        }
      }, [_c('label', {
        staticClass: "als-st-opt"
      }, [_c('input', {
        attrs: {
          "type": "radio",
          "name": 'rs-' + row.id
        },
        domProps: {
          "checked": _vm.rowSettingsFor(row).rating_sensitivity === 'half_star'
        },
        on: {
          "change": function($event) {
            return _vm.setRowSetting(row, 'rating_sensitivity', 'half_star')
          }
        }
      }), _vm._v("\n                Every half-star the customer sees (default)\n              ")]), _vm._v(" "), _c('label', {
        staticClass: "als-st-opt"
      }, [_c('input', {
        attrs: {
          "type": "radio",
          "name": 'rs-' + row.id
        },
        domProps: {
          "checked": _vm.rowSettingsFor(row).rating_sensitivity === 'tenth'
        },
        on: {
          "change": function($event) {
            return _vm.setRowSetting(row, 'rating_sensitivity', 'tenth')
          }
        }
      }), _vm._v("\n                Every 0.1 drop\n              ")])]), _vm._v(" "), _c('div', {
        staticClass: "als-settings-line"
      }, [_c('span', {
        staticClass: "als-subrow-label"
      }, [_vm._v("Minimum rating-count drop")]), _vm._v(" "), _c('input', {
        staticClass: "als-delay-input",
        attrs: {
          "type": "number",
          "min": "1",
          "step": "1"
        },
        domProps: {
          "value": _vm.rowSettingsFor(row).min_rating_count_drop
        },
        on: {
          "change": function($event) {
            return _vm.onMinRatingCountDropChange(row, $event)
          }
        }
      })])]) : _vm._e(), _vm._v(" "), (_vm.hasMultiMp && (row.alwaysOn || (row.digestFixed && _vm.rowOn(row) && !_vm.rowLocked(row)))) ? _c('p', {
        staticClass: "als-mp-follow als-mp-follow-row"
      }, [_vm._v("\n            Marketplaces: follows your default ("), _c('b', [_vm._v(_vm._s(_vm.mpScopeSummary(_vm.defaultMpScope, _vm.mpStorefrontsAll)))]), _vm._v("). " + _vm._s(row.alwaysOn ? 'Always-on alerts can\'t have their own set.' : 'This digest can\'t have its own set.') + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.mpBoxVisible(row)) ? _c('details', {
        staticClass: "als-bf als-mp",
        attrs: {
          "open": !!_vm.mpBoxOpen[row.id]
        },
        on: {
          "toggle": function($event) {
            return _vm.$set(_vm.mpBoxOpen, row.id, $event.target.open)
          }
        }
      }, [_c('summary', {
        staticClass: "als-bf-head"
      }, [_c('span', {
        staticClass: "als-bf-caret"
      }, [_vm._v("▸")]), _vm._v("Marketplaces\n              "), _c('span', {
        staticClass: "als-bf-sub"
      }, [_vm._v("— " + _vm._s(_vm.rowMpOwn(row) ? 'own set' : 'follows default'))])]), _vm._v(" "), _c('p', {
        staticClass: "als-bf-hint"
      }, [_vm._v("Which marketplaces send this alert. Use your default, or pick a different set just for this alert.")]), _vm._v(" "), _c('div', {
        staticClass: "als-seg als-mp-mode",
        attrs: {
          "role": "group",
          "aria-label": row.title + ' marketplace mode'
        }
      }, [_c('button', {
        class: ['als-seg-btn', {
          active: !_vm.rowMpOwn(row)
        }],
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            return _vm.setRowMpMode(row, false)
          }
        }
      }, [_vm._v("Use default")]), _vm._v(" "), _c('button', {
        class: ['als-seg-btn', {
          active: _vm.rowMpOwn(row)
        }],
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            return _vm.setRowMpMode(row, true)
          }
        }
      }, [_vm._v("Own marketplaces")])]), _vm._v(" "), (_vm.rowMpOwn(row)) ? _vm._l((_vm.mpStorefronts(row)), function(sf) {
        return _c('div', {
          key: 'mp-' + row.id + '-' + sf.key,
          staticClass: "als-bf-line"
        }, [(_vm.mpStorefronts(row).length > 1) ? _c('span', {
          staticClass: "als-bf-name"
        }, [_vm._v(_vm._s(sf.name))]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "als-mp-chips",
          attrs: {
            "role": "group",
            "aria-label": sf.name + ' marketplaces for ' + row.title
          }
        }, [_c('button', {
          class: ['als-mp-chip', 'als-mp-chip-all', {
            active: _vm.mpIsAll(_vm.rowMpScope[row.id], sf)
          }],
          attrs: {
            "type": "button",
            "aria-pressed": _vm.mpIsAll(_vm.rowMpScope[row.id], sf) ? 'true' : 'false'
          },
          on: {
            "click": function($event) {
              return _vm.setMpAll(_vm.rowMpScope[row.id], sf)
            }
          }
        }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.sfMpCodes(sf)), function(mp) {
          return _c('button', {
            key: 'rmp-' + row.id + '-' + sf.key + '-' + mp.code,
            class: ['als-mp-chip', {
              active: _vm.mpChipOn(_vm.rowMpScope[row.id], sf, mp.code)
            }],
            attrs: {
              "type": "button",
              "aria-pressed": _vm.mpChipOn(_vm.rowMpScope[row.id], sf, mp.code) ? 'true' : 'false'
            },
            on: {
              "click": function($event) {
                return _vm.toggleMpChip(_vm.rowMpScope[row.id], sf, mp.code)
              }
            }
          }, [_c('i', {
            class: _vm.mpFlagClass(mp.raw) + ' flag'
          }), _vm._v(_vm._s(_vm.mpLabel(mp.raw)))])
        })], 2), _vm._v(" "), (_vm.mpStale(_vm.rowMpScope[row.id], sf)) ? _c('p', {
          staticClass: "als-mp-warn"
        }, [_vm._v("No active marketplace selected for " + _vm._s(sf.name) + ". This alert sends nothing for it.")]) : _vm._e()])
      }) : _c('p', {
        staticClass: "als-mp-follow"
      }, [_vm._v("Following default: "), _c('b', [_vm._v(_vm._s(_vm.mpScopeSummary(_vm.defaultMpScope, _vm.mpStorefronts(row))))])]), _vm._v(" "), _c('p', {
        staticClass: "als-bf-ro"
      }, [_vm._v("Applies only to " + _vm._s(_vm.selectedUserEmail === _vm.loginEmail ? 'your' : _vm.selectedUserEmail + '’s') + " emails")])], 2) : _vm._e(), _vm._v(" "), (row.brandFilter && _vm.rowOn(row) && !_vm.rowLocked(row) && _vm.brandStorefronts(row).length) ? _c('details', {
        staticClass: "als-bf",
        attrs: {
          "open": _vm.brandFilterIsOpen(row.brandFilter)
        },
        on: {
          "toggle": function($event) {
            return _vm.setBrandFilterOpen(row.brandFilter, $event.target.open)
          }
        }
      }, [_c('summary', {
        staticClass: "als-bf-head"
      }, [_c('span', {
        staticClass: "als-bf-caret"
      }, [_vm._v("▸")]), _vm._v("Brand filter\n              "), _c('span', {
        staticClass: "als-bf-sub"
      }, [_vm._v("— optional" + _vm._s(_vm.brandFilterSummary(row)))])]), _vm._v(" "), _c('p', {
        staticClass: "als-bf-hint"
      }, [_vm._v(_vm._s(row.brandFilterHint) + " Leave empty to be alerted on every listing.")]), _vm._v(" "), _vm._l((_vm.brandStorefronts(row)), function(sf) {
        return _c('div', {
          key: 'bf-' + row.brandFilter + '-' + sf.key,
          staticClass: "als-bf-line"
        }, [(_vm.brandStorefronts(row).length > 1) ? _c('span', {
          staticClass: "als-bf-name"
        }, [_vm._v(_vm._s(sf.name))]) : _vm._e(), _vm._v(" "), (!_vm.brandsFor(row.brandFilter, sf.id).length) ? _c('span', {
          staticClass: "als-bf-all"
        }, [_vm._v("All brands")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.brandsFor(row.brandFilter, sf.id)), function(b, bi) {
          return _c('span', {
            key: 'bp-' + row.brandFilter + '-' + sf.key + '-' + bi,
            staticClass: "als-bf-pill"
          }, [_vm._v("\n                " + _vm._s(b) + "\n                "), (_vm.brandFilterEditable) ? _c('button', {
            staticClass: "als-bf-x",
            attrs: {
              "type": "button",
              "aria-label": 'Remove ' + b
            },
            on: {
              "click": function($event) {
                return _vm.removeBrand(row.brandFilter, sf.id, bi)
              }
            }
          }, [_vm._v("×")]) : _vm._e()])
        }), _vm._v(" "), (_vm.brandFilterEditable) ? _c('div', {
          staticClass: "als-bf-add",
          on: {
            "click": function($event) {
              $event.stopPropagation();
            }
          }
        }, [_c('button', {
          staticClass: "als-bf-add-btn",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.toggleBrandPicker(row.brandFilter, sf.id, row.id)
            }
          }
        }, [_vm._v("+ Add brand ▾")]), _vm._v(" "), (_vm.brandPickerKey === _vm.brandPickerKeyFor(row.id, sf.id)) ? _c('div', {
          staticClass: "als-bf-pick"
        }, [_c('input', {
          staticClass: "als-bf-search",
          attrs: {
            "type": "text",
            "placeholder": "Search or type a brand"
          },
          domProps: {
            "value": _vm.brandQuery
          },
          on: {
            "input": function($event) {
              return _vm.onBrandQuery(sf.id, $event.target.value)
            },
            "keydown": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              $event.preventDefault();
              return _vm.addTypedBrand(row.brandFilter, sf.id)
            }
          }
        }), _vm._v(" "), (_vm.brandOptionsLoading) ? _c('p', {
          staticClass: "als-bf-empty"
        }, [_vm._v("Loading brands…")]) : [_vm._l((_vm.brandPickerOptions(row.brandFilter, sf.id)), function(opt) {
          return _c('button', {
            key: 'bo-' + opt.brand,
            staticClass: "als-bf-opt",
            attrs: {
              "type": "button"
            },
            on: {
              "click": function($event) {
                return _vm.addBrand(row.brandFilter, sf.id, opt.brand)
              }
            }
          }, [_c('span', [_vm._v(_vm._s(opt.brand))]), _c('small', [_vm._v(_vm._s(opt.asin_count) + " ASIN" + _vm._s(opt.asin_count === 1 ? '' : 's'))])])
        }), _vm._v(" "), (_vm.brandQueryIsCustom(row.brandFilter, sf.id)) ? _c('button', {
          staticClass: "als-bf-opt als-bf-custom",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.addTypedBrand(row.brandFilter, sf.id)
            }
          }
        }, [_vm._v("Use “" + _vm._s(_vm.brandQuery.trim()) + "”")]) : _vm._e(), _vm._v(" "), (!_vm.brandPickerOptions(row.brandFilter, sf.id).length && !_vm.brandQueryIsCustom(row.brandFilter, sf.id)) ? _c('p', {
          staticClass: "als-bf-empty"
        }, [_vm._v("No more brands in this catalog")]) : _vm._e()]], 2) : _vm._e()]) : _vm._e()], 2)
      }), _vm._v(" "), _c('p', {
        staticClass: "als-bf-ro"
      }, [_vm._v("Applies only to " + _vm._s(_vm.selectedUserEmail === _vm.loginEmail ? 'your' : _vm.selectedUserEmail + '’s') + " emails" + _vm._s(_vm.brandFilterEditable ? '' : ' · Only the account owner or an admin can edit another user’s filter'))])], 2) : _vm._e(), _vm._v(" "), (!row.alwaysOn && !_vm.deliveryRealtimeBadgeOnly(row) && (row.digestFixed || _vm.deliveryFor(row) === 'daily') && _vm.rowOn(row) && !_vm.rowLocked(row)) ? _c('div', {
        staticClass: "als-subrow"
      }, [_c('span', {
        staticClass: "als-subrow-label"
      }, [_vm._v("Send at")]), _vm._v(" "), _c('select', {
        staticClass: "als-time-select",
        domProps: {
          "value": _vm.digestHourForRow(row.id)
        },
        on: {
          "change": function($event) {
            _vm.setDigestHourForRow(row.id, Number($event.target.value))
          }
        }
      }, _vm._l((_vm.digestHourOptions), function(h) {
        return _c('option', {
          key: h,
          domProps: {
            "value": h
          }
        }, [_vm._v(_vm._s(_vm.formatDigestHour(h)))])
      }), 0), _vm._v(" "), _c('span', {
        staticClass: "als-subrow-hint"
      }, [_vm._v(_vm._s(row.digestFixed ? 'Browser local time' : 'Browser local time · consolidated with other daily alerts'))])]) : _vm._e(), _vm._v(" "), (!row.alwaysOn && !row.digestFixed && !_vm.deliveryRealtimeBadgeOnly(row) && _vm.deliveryFor(row) === 'weekly' && _vm.rowOn(row) && !_vm.rowLocked(row)) ? _c('div', {
        staticClass: "als-subrow"
      }, [_c('span', {
        staticClass: "als-subrow-label"
      }, [_vm._v("Every")]), _vm._v(" "), _c('select', {
        staticClass: "als-time-select",
        domProps: {
          "value": _vm.weeklyDay[row.id] || _vm.weeklyScheduleDayDefault
        },
        on: {
          "change": function($event) {
            return _vm.setWeeklyDay(row.id, $event.target.value)
          }
        }
      }, _vm._l((_vm.weekDaysList), function(d) {
        return _c('option', {
          key: d.api,
          domProps: {
            "value": d.api
          }
        }, [_vm._v(_vm._s(d.label))])
      }), 0), _vm._v(" "), _c('span', {
        staticClass: "als-subrow-label"
      }, [_vm._v("at")]), _vm._v(" "), _c('select', {
        staticClass: "als-time-select",
        domProps: {
          "value": _vm.digestHourForRow(row.id)
        },
        on: {
          "change": function($event) {
            _vm.setDigestHourForRow(row.id, Number($event.target.value))
          }
        }
      }, _vm._l((_vm.digestHourOptions), function(h) {
        return _c('option', {
          key: 'wh-' + h,
          domProps: {
            "value": h
          }
        }, [_vm._v(_vm._s(_vm.formatDigestHour(h)))])
      }), 0), _vm._v(" "), _c('span', {
        staticClass: "als-subrow-hint"
      }, [_vm._v("Browser local time · consolidated with other weekly alerts")])]) : _vm._e()])
    })], 2)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "als-footer-bar"
  }, [_c('button', {
    staticClass: "als-btn als-btn-primary",
    class: {
      'als-btn-loading': _vm.saving
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.hasChanges || _vm.saving || _vm.hasDelayValidationError
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save Preferences")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "als-slide-up"
    }
  }, [(_vm.successMsg) ? _c('div', {
    staticClass: "als-toast als-toast-ok"
  }, [_vm._v(_vm._s(_vm.successMsg))]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "als-slide-up"
    }
  }, [(_vm.errorMsg) ? _c('div', {
    staticClass: "als-toast als-toast-err"
  }, [_vm._v(_vm._s(_vm.errorMsg))]) : _vm._e()])] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "als-page-head"
  }, [_c('div', {
    staticClass: "als-page-head-text"
  }, [_c('h1', {
    staticClass: "als-title"
  }, [_vm._v("Alert Settings")]), _vm._v(" "), _c('p', {
    staticClass: "als-subtitle"
  }, [_vm._v("Choose which alerts you receive and how often.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "als-hint-body"
  }, [_c('strong', [_vm._v("Real-time")]), _vm._v(" alerts deliver the moment Amazon broadcasts the change. "), _c('strong', [_vm._v("Daily")]), _vm._v(" bundles changes into one morning email. "), _c('strong', [_vm._v("Weekly")]), _vm._v(" rolls them into your Monday digest.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "als-config-title"
  }, [_vm._v("Offer activity digest")]), _vm._v(" "), _c('p', {
    staticClass: "als-config-hint"
  }, [_vm._v("When on, Buy Box losses to Amazon Retail or authorised resellers batch every 15 minutes instead of sending immediately. Ignore still never emails.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "als-config-title"
  }, [_vm._v("Notification language")]), _vm._v(" "), _c('p', {
    staticClass: "als-config-hint"
  }, [_vm._v("Email labels and copy only — your listing titles and Amazon field values are never translated. Saves automatically when you change the selection.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5648897c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/AlertSettings.vue
// module id = 777
// module chunks = 2